import { Expr_Inst } from './expr_inst';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Attribute } from './attribute';
import { DataMaskingInst } from './datamaskinginst ';

export class DataMasking {
    dataMaskingInst: DataMaskingInst;
    attributes: Array<Attribute>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    fldr_Id: number;
    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.dataMaskingInst = new DataMaskingInst();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
    }

    static parse(maskingTmp: DataMasking): DataMasking {
        let datamasking: DataMasking = new DataMasking();
        datamasking.copyFrom(maskingTmp);
        return datamasking;
    }

    copy(): DataMasking {
        let dataMaskingTmp: DataMasking = new DataMasking();

        dataMaskingTmp.dataMaskingInst = this.dataMaskingInst.copy();
        dataMaskingTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        dataMaskingTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        dataMaskingTmp.ref_Id = this.ref_Id;
        dataMaskingTmp.ref_Cd = this.ref_Cd;
        dataMaskingTmp.fldr_Id = this.fldr_Id;
        dataMaskingTmp.is_In_SubFlow = this.is_In_SubFlow;

        dataMaskingTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        dataMaskingTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        dataMaskingTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        dataMaskingTmp.change_Ind = this.change_Ind;
        dataMaskingTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        dataMaskingTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        dataMaskingTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        dataMaskingTmp.error_Cd = this.error_Cd;
        dataMaskingTmp.error_Msg = this.error_Msg;

        return dataMaskingTmp;
    }

    copyFrom(dataMaskingTmp: DataMasking): void {
        this.dataMaskingInst.copyFrom(dataMaskingTmp.dataMaskingInst);

        AttributesUtil.getInstance().copyFrom(this.attributes, dataMaskingTmp.attributes);

        this.nativeDbTyp_Id = dataMaskingTmp.nativeDbTyp_Id;
        this.ref_Id = dataMaskingTmp.ref_Id;
        this.ref_Cd = dataMaskingTmp.ref_Cd;
        this.fldr_Id = dataMaskingTmp.fldr_Id;
        this.is_In_SubFlow = dataMaskingTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = dataMaskingTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, dataMaskingTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, dataMaskingTmp.runPropertyTypes);

        this.change_Ind = dataMaskingTmp.change_Ind;
        this.gen_Tab_Change_Ind = dataMaskingTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = dataMaskingTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = dataMaskingTmp.rProp_Tab_Change_Ind;

        this.error_Cd = dataMaskingTmp.error_Cd;
        this.error_Msg = dataMaskingTmp.error_Msg;
    }

    compare(dataMaskingTmp: DataMasking): string {
        let diffString: string = this.dataMaskingInst.compare(dataMaskingTmp.dataMaskingInst);
        if( diffString != '') return diffString;

        diffString = this.toBaseCompare(dataMaskingTmp);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, dataMaskingTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, dataMaskingTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, dataMaskingTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(dataMaskingTmp: DataMasking): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = dataMaskingTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DataMasking [dataMaskingInst=" + this.dataMaskingInst.toString() + this.toBaseString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind +
                ", error_Cd=" + this.error_Cd + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
                ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
                ", error_Msg=" + this.error_Msg + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }

    toBaseString(): string {
        return ", fldr_Id=" + this.fldr_Id + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
        ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }
}